<template>
    <div class="action_line">
        <p class="check_all" v-if="multipleActionOptions">
            <input id="check-all-bottom" type="checkbox" v-model="toggleSelectAll">
            <label for="check-all-bottom" v-translate>Vybrat vše</label>
            <select id="akce" name="akce" v-model="selectedMultipleAction">
                <option v-for="option in multipleActionOptions" :value="option.value">
                    {{ option.text }}
                </option>
            </select>
            <input class="btn" type="submit" :value="'Provést' | translate" @click.prevent="emitMultipleAction">
        </p>
    </div>
</template>

<script>

	export default {
		name: "LocalListActionLine",
		data: () => {
			return {
				selectedMultipleAction: 'choose'
			}
		},
		props: {
			entities: Array | Object,
			selectedEntities: {
				type: Array,
				default: () => {
					return []
				},
			},
			multipleActionOptions: Array,
		},
		computed: {
			toggleSelectAll: {
				get() {
					return (this.selectedEntities.length === this.entities.length && this.entities.length !== 0)
				},
				set(value) {
					this.$emit('select-all', value)
				}
			}
		},
		methods: {
			emitMultipleAction() {
				this.$emit('run-multiple-action', this.selectedMultipleAction)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/LocalListActionLine.vue